import { combineReducers, configureStore } from '@reduxjs/toolkit';
import appStateReducer from './slices/appStateSlice';
import quoteDataReducer from './slices/quoteDataSlice';
import quoteResponseReducer from './slices/quoteResponseSlice';
import utmParametersReducer from './slices/utmSlice';
import addressResultsReducer from './slices/addressResultsSlice';
import applicationSubmissionReducer from './slices/applicationSubmissionSlice';
import agentDetailsReducer from './slices/agentDetailsSlice';

const enableLogging = process.env.NODE_ENV !== 'production';

// Enables logging dispatch data to client console when developing
const logger = store => next => action => {
  const excludedActions = ['appState/addErrorMessage', 'appState/removeErrorMessage'];
  if (!enableLogging || excludedActions.includes(action.type)) {
    return next(action);
  }
  console.groupCollapsed(action.type);
  console.info('Dispatching:', action);
  let result = next(action);
  console.info('New state:', store.getState());
  console.groupEnd();
  return result;
};

const rootReducer = combineReducers({
  appState: appStateReducer,
  quoteData: quoteDataReducer,
  quoteResponse: quoteResponseReducer,
  utms: utmParametersReducer,
  addressResults: addressResultsReducer,
  applicationSubmission: applicationSubmissionReducer,
  agentDetails: agentDetailsReducer,
});

export const setupStore = (preloadedState = {}, attachLogger = enableLogging) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      attachLogger ? getDefaultMiddleware().prepend(logger) : getDefaultMiddleware(),
    preloadedState,
  });

  if (typeof window !== 'undefined') {
    // Make dispatch events available to content using javascript:_edh.dispatch()
    window._edh = window._edh || {};
    window._edh.dispatch = store.dispatch;
  }

  if (attachLogger) {
    console.groupCollapsed('Initial Store');
    console.info(store.getState());
    console.groupEnd();
  }

  return store;
};

export default setupStore();
